export function flattenJSON(json: any[]) {
  // @ts-ignore
  const results = [];
  Object.values(json).forEach((obj) => {
    const row = {};
    flattenRow([], obj, row);
    results.push(row);
  });
  // @ts-ignore
  return results;
}

function flattenRow(ancestors: string[], obj: any, row: any) {
  if (typeof obj === 'object') {
    Object.keys(obj).forEach((key) => {
      if (!obj[key]) {
        obj[key] = '';
      }
      if (typeof obj[key] === 'object') {
        flattenRow([...ancestors, key], obj[key], row);
      } else {
        row[[...ancestors, key].join('.')] = obj[key];
      }
    });
  }
}
